/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-console */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/button-has-type */

// eslint-disable-next-line max-classes-per-file
import React from 'react';
import Select from 'react-select';
import SignaturePad from 'react-signature-canvas';
import ReactBootstrapSlider from 'react-bootstrap-slider';
//import Slider, { Range } from 'rc-slider';
//import 'rc-slider/assets/index.css';
import TextAreaAutosize from 'react-textarea-autosize';
import StarRating from './star-rating';
import HeaderBar from './header-bar';
import DatePicker from './date-picker';
import ComponentHeader from './component-header';
import ComponentLabel from './component-label';
//import "bootstrap-slider/dist/css/bootstrap.css";
import 'bootstrap-slider/dist/css/bootstrap-slider.css';
import myxss from './myxss';
import services from 'services/services';
import xhr from 'xhr.js';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';

import ReactS3Uploader from 'react-s3-uploader';
import { Combobox } from 'components/Combobox';
import { Flex, Box, Heading, Button } from 'rebass';
import { Label as RebassLabel, Textarea, Input } from '@rebass/forms';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import helpers from 'utils/helpers';
import helpersScreener from 'utils/helpers-screener';
import {
    SCREENER_QUESTION_ERRORS_CLASSNAME,
    VALIDATION_EXACT,
    VALIDATION_MAXIMUM,
    VALIDATION_MINIMUM
} from 'utils/constants';
import { getElementLabel } from './getElementLabel';
import matrixStyles from 'styles/matrix.module.css';

import RecordRTC from 'recordrtc';

import {
    FiUploadCloud,
    FiCheckCircle,
    FiMonitor,
    FiRotateCcw,
    FiVideoOff,
    FiVideo,
    FiStopCircle,
    FiTrash2,
    FiAlertCircle
} from 'react-icons/fi';
import Badge from 'components/Badge';

function isNonStandardOption(option) {
    return option.is_add_other || option.is_none_of_the_above;
}

function renderNonStandardOption(option, element_add_other, element_none_of_the_above) {
    if (option.is_add_other) {
        return element_add_other;
    } else if (option.is_none_of_the_above) {
        return element_none_of_the_above;
    }
}

const FormElements = {};

class Header extends React.Component {
    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        return (
            <div className={baseClasses}>
                {this.props.editElement ? (
                    this.props.editElement
                ) : (
                    <div>
                        {helpersScreener.showQuestionNumber(this.props.all_questions, this.props.data)}
                        <Box className="fs-headline-24 color-text-primary">
                            <h1
                                style={{ whiteSpace: 'pre-wrap', margin: 0 }}
                                className="quill-render fs-headline-24 color-text-primary"
                                dangerouslySetInnerHTML={{ __html: myxss.process(this.props.data.content) }}
                            />
                        </Box>
                        <ComponentLabel
                            {...this.props}
                            isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                        />
                    </div>
                )}
            </div>
        );
    }
}

class Paragraph extends React.Component {
    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        return (
            <div className={baseClasses}>
                {this.props.editElement ? (
                    this.props.editElement
                ) : (
                    <div>
                        {helpersScreener.showQuestionNumber(this.props.all_questions, this.props.data)}
                        <Box className="fs-body-16 color-text-secondary">
                            <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                className="quill-render"
                                dangerouslySetInnerHTML={{ __html: myxss.process(this.props.data.content) }}
                            />
                        </Box>
                        <ComponentLabel
                            {...this.props}
                            isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                        />
                    </div>
                )}
            </div>
        );
    }
}

class Label extends React.Component {
    render() {
        let classNames = 'static';
        if (this.props.data.bold) {
            classNames += ' bold';
        }
        if (this.props.data.italic) {
            classNames += ' italic';
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        return (
            <div className={baseClasses}>
                {this.props.editElement ? (
                    this.props.editElement
                ) : (
                    <div>
                        <ComponentHeader {...this.props} />
                        <label
                            className={classNames}
                            dangerouslySetInnerHTML={{ __html: myxss.process(this.props.data.content) }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

class LineBreak extends React.Component {
    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        return (
            <div className={baseClasses}>
                {this.props.editElement ? (
                    this.props.editElement
                ) : (
                    <div>
                        <ComponentHeader {...this.props} />
                        <hr />
                    </div>
                )}
            </div>
        );
    }
}

class AddPipeInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            recordVideo: null,
            src: null,
            permissionAllowed: false,
            uploadSuccess: null,
            isRecordingVideo: false,
            isUploadingVideo: false,
            hasRecordedVideo: false,
            hasUploadedVideo: false,
            isCountingDown: false,
            uploadVideoError: false
        };
        this.inputField = React.createRef();

        this.requestUserMedia = this.requestUserMedia.bind(this);
        this.allowRecord = this.allowRecord.bind(this);
        this.startRecord = this.startRecord.bind(this);
        this.stopRecord = this.stopRecord.bind(this);
        this.uploadVideo = this.uploadVideo.bind(this);
        this.uploadVideoNotIos = this.uploadVideoNotIos.bind(this);
        this.clickRecordMobile = this.clickRecordMobile.bind(this);

        const randomId = helpers.ID();
        this.videoWrapperId = `video-wrapper-${randomId}`;
        this.videoTimerId = `video-timer-${randomId}`;
        this.videoRecorderId = `video-rec-${randomId}`;
        this.videoControlsId = `video-controls-${randomId}`;
    }

    getAutocompleteAttribute() {
        //return 'name';
    }

    getAddPipeContainerId() {
        return this.props.data.id + '-addpipe-container';
    }

    captureUserMedia(callback) {
        navigator.mediaDevices
            .getUserMedia({ video: true, audio: { echoCancellation: true } })
            .then(function(camera) {
                callback(camera);
            })
            .catch(function(error) {
                alert('Unable to capture your camera. Please allow video capture.');
                console.error(error);
                helpers.trackError(error);
            });
    }

    resetToStartRecord(element) {
        if (element) {
            element.muted = true;
            element.volume = 0;
            element.controls = 0;
            element.autoplay = 1;
        }
    }

    requestUserMedia() {
        console.log('requestUserMedia');
        this.captureUserMedia(camera => {
            console.log('camera', camera);

            const element = document.getElementById(this.videoRecorderId);
            this.resetToStartRecord(element);

            if ('srcObject' in element) {
                element.srcObject = camera;
            } else if ('mozSrcObject' in element) {
                element.mozSrcObject = camera;
            } else {
                element.srcObject = camera;
            }

            //console.log('setting state', this.state)

            this.setState({
                permissionAllowed: true
            });

            const timer = document.getElementById(this.videoTimerId);
            if (timer) {
                timer.innerHTML = '';
            }
        });
    }

    allowRecord() {
        this.prepareToReRecord();

        const hasGetUserMedia = !!(
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia ||
            // for safari
            (navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
        );

        if (!hasGetUserMedia) {
            alert(
                'Your browser cannot stream from your webcam. Please switch to Chrome, Firefox, or the latest version of Safari.'
            );
            return;
        }
        this.requestUserMedia();
    }

    startRecordingTimer() {
        this.startRecordingTimerInterval = setInterval(() => {
            this.decreaseTimeRemaining();
        }, 1000);
    }

    startRecord() {
        this.setState({ isCountingDown: true });

        const defaultSeconds = this.props.data.video_recording_time ? this.props.data.video_recording_time : 120;

        //const element_controls = document.getElementById(this.videoControlsId);
        //element_controls.style.display = 'none';

        const element = document.getElementById(this.videoRecorderId);
        this.resetToStartRecord(element);

        let i = 3;
        const timer = document.getElementById(this.videoTimerId);
        if (timer) {
            timer.style.display = 'block';
            timer.innerHTML = i;
        }

        let interval = setInterval(() => {
            i--;

            if (timer) {
                timer.innerHTML = i;
            }

            if (i == 0) {
                this.setState({
                    isRecordingVideo: true,
                    isCountingDown: false,
                    timeRemaining: defaultSeconds
                });

                if (timer) {
                    timer.innerHTML = '';
                }
                //console.log('STARTING TO RECORD')
                clearInterval(interval);

                const camera = element.srcObject;

                this.state.recordVideo = RecordRTC(camera, { type: 'video' });
                this.state.recordVideo.startRecording();

                if (timer) {
                    timer.style.display = 'none';
                }

                this.startRecordingTimer();
            }
        }, 1000);
    }

    decreaseTimeRemaining() {
        console.log('decreaseTimeRemaining');
        if (this.state.timeRemaining === 0) {
            this.stopRecord();
        }

        this.setState(prevState => ({ ...prevState, timeRemaining: prevState.timeRemaining - 1 }));
    }

    stopRecord() {
        if (this.startRecordingTimerInterval) {
            clearInterval(this.startRecordingTimerInterval);
            console.log('clear startRecordingTimerInterval');
        } else {
            console.log('NOT FOUND clear startRecordingTimerInterval');
        }

        this.setState({ isRecordingVideo: false });

        //const element_controls = document.getElementById(this.videoControlsId);
        //element_controls.style.display = 'block';

        const element_timer = document.getElementById(this.videoTimerId);
        if (element_timer) {
            element_timer.style.display = 'none';
        }

        this.state.recordVideo.stopRecording(() => {
            this.setState({ hasRecordedVideo: true });

            if (element_timer) {
                element_timer.innerHTML = '';
            }

            const element = document.getElementById(this.videoRecorderId);
            element.src = element.srcObject = null;

            element.src = URL.createObjectURL(this.state.recordVideo.getBlob());
            element.muted = false;
            element.volume = 1;
            element.controls = 1;
            element.autoplay = 0;
            //console.log(element.src)

            this.state.recordVideo.stopRecording();

            this.uploadVideoNotIos();
        });
    }

    uploadFromIOS(file) {
        try {
            const blob = file.slice(0, file.size, 'video/mp4');

            let params = {
                type: 'video/mp4',
                data: blob,
                id: Math.floor(Math.random() * 90000) + 10000
            };
            this.uploadVideo(params);
        } catch (e) {
            helpers.trackError(e);
        }
    }

    prepareToReRecord() {
        // un-set the value so user cant "submit" (if re-recording)
        const videoFileLink = '';
        this.setVideoLinkInAnswer(videoFileLink);

        this.setState({
            isUploadingVideo: false,
            hasUploadedVideo: false,
            hasRecordedVideo: false
        });
    }

    clickRecordMobile() {
        if (this.state.hasRecordedVideo == true) {
            if (!confirm('Delete recording and start over?')) {
                return;
            }
        }
        this.prepareToReRecord();
        document.getElementById('video_file').click();
    }

    uploadVideoNotIos() {
        let params = {
            type: 'video/webm',
            data: this.state.recordVideo.blob,
            id: Math.floor(Math.random() * 90000) + 10000
        };
        this.uploadVideo(params);
    }

    uploadVideo(params) {
        this.setState({ isUploadingVideo: true, uploadVideoError: false });

        this.getSignedUrl(params, signedUrlResponse => {
            var options = {
                headers: {
                    'Content-Type': params.type
                }
            };

            xhr.put(signedUrlResponse.signedUrl, params.data, options)
                .then(ok => {
                    console.log(ok);

                    console.log('uploaded', signedUrlResponse.fileName);

                    this.setVideoLinkInAnswer(signedUrlResponse.fileName);
                    this.setState({ isUploadingVideo: false, hasUploadedVideo: true });
                })
                .catch(error => {
                    this.setState({ isUploadingVideo: false, uploadVideoError: true });
                    helpers.trackError(error);
                    alert('Error, try to upload again.');
                    //this.allowRecord();
                });
            console.log('ready to upload', signedUrlResponse);
        });

        /*S3Upload(params)
            .then((success) => {
                console.log('enter then statement')
                if(success) {
                    console.log(success)
                    this.setState({ uploadSuccess: true, isUploadingVideo: false });
                }
            }, (error) => {
                alert(error, 'error occurred. check your aws settings and try again.')
            }
        )*/
    }

    componentDidCatch(error, errorInfo) {
        helpers.trackError(error);
    }

    componentDidMount() {
        return;

        // old addpipe stuff

        const that = this;
        //console.log(that.props);
        //console.log('this.props', this.props, this.props.read_only)
        if (that.props.addpipe_token && that.props.addpipe_eid && !this.props.editElement && !this.props.read_only) {
            const addPipeLoading = setInterval(() => {
                const addPipeContainerId = this.getAddPipeContainerId();
                const addPipeContainerElement = document.getElementById(addPipeContainerId);
                //console.log('addPipeContainerElement', addPipeContainerElement)

                if (window.PipeSDK && addPipeContainerElement) {
                    let accountHash = that.props.addpipe_token;
                    var pipeParams = {
                        size: { width: 640, height: 390 },
                        qualityurl: 'avq/360p.xml',
                        accountHash: accountHash,
                        eid: that.props.addpipe_eid,
                        mrt: 120,
                        cornerradius: 4
                    };

                    PipeSDK.insert(addPipeContainerId, pipeParams, function(recorderObject) {
                        recorderObject.onReadyToRecord = function() {
                            console.log('ready to record!!!');
                        };

                        recorderObject.onSaveOk = function(
                            recorderId,
                            streamName,
                            streamDuration,
                            cameraName,
                            micName,
                            audioCodec,
                            videoCodec,
                            fileType,
                            videoId,
                            audioOnly,
                            location
                        ) {
                            //onSaveOK is part of the desktop recorder's JS events API (recording from camera or screen)
                            const link = 'https://' + location + '/' + accountHash + '/' + streamName + '.mp4';
                            that.setVideoLinkInAnswer(link);
                        };
                        recorderObject.onVideoUploadSuccess = function(
                            recorderId,
                            filename,
                            filetype,
                            videoId,
                            audioOnly,
                            location
                        ) {
                            //onVideoUploadSuccess is part of the native mobile recorder's JS events API (upload new or existing recording)
                            const link = 'https://' + location + '/' + accountHash + '/' + streamName + '.mp4';
                            that.setVideoLinkInAnswer(link);
                        };
                        recorderObject.onDesktopVideoUploadSuccess = function(
                            recorderId,
                            filename,
                            filetype,
                            videoId,
                            audioOnly,
                            location
                        ) {
                            //onDesktopVideoUploadSuccess is part of the desktop recorder's JS events API (upload existing file from desktop)
                            const link = 'https://' + location + '/' + accountHash + '/' + streamName + '.mp4';
                            that.setVideoLinkInAnswer(link);
                        };
                    });
                    clearInterval(addPipeLoading);
                    console.log('ADDPIPE FOUND');
                } else {
                    console.log('ADDPIPE not found');
                }
            }, 100);
        }
    }

    setVideoLinkInAnswer(link) {
        //document.getElementById(addPipeContainerId).value = link;
        try {
            this.inputField.current.value = link;

            if (this.props.handleChange) {
                //console.log('fire handlechange')
                this.props.handleChange();
            }
        } catch (e) {
            helpers.trackError(e);
        }
    }

    getSignedUrl(file, callback) {
        if (file) {
            console.log('getting preseign url');
            services
                .getAwsSignedUrlForScreenerVideo(file.type)
                .then(response => {
                    //console.log(response);
                    callback(response);
                })
                .catch(error => {
                    alert('Upload error, please try again.');
                    this.setState({ isUploadingVideo: false });
                    helpers.trackError(error);
                });
        } else {
            /*
            addToast('File not found', {
                appearance: 'error',
                autoDismiss: false
            });
            */
            //setBulkImportProcessing(false);
        }
    }

    render() {
        const props = {};
        props.type = 'text';
        props.className = 'form-control';
        props.name = this.props.data.field_name;
        if (this.props.mutable) {
            props.defaultValue = this.props.defaultValue;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        if (this.props.read_only || this.props.is_disabled) {
            props.disabled = 'disabled';
        }
        //console.log('this.props.read_only', this.props.read_only)
        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        //console.log('should_show', should_show)
        //console.log('textinput', this.props.data.label, should_show, this.props.all_questions)
        if (should_show || this.props.editElement || this.props.read_only) {
            //console.log('this.props.defaultValue', this.props.defaultValue)
            const video_link = helpersScreener.getVideoLinkFromScreenerAnswer(this.props.defaultValue);
            const { h, m, s } = helpers.secondsToTime(this.state.timeRemaining);

            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                {this.props.read_only ? (
                                    <>
                                        {video_link ? (
                                            <a href={video_link} target="_blank">
                                                View video
                                            </a>
                                        ) : (
                                            'No video'
                                        )}
                                    </>
                                ) : (
                                    <div>
                                        <div id={this.getAddPipeContainerId()}></div>

                                        {helpers.is_iOS() ? (
                                            <>
                                                <Button
                                                    type="button"
                                                    variant={
                                                        this.state.hasUploadedVideo == true ? 'secondary' : 'primary'
                                                    }
                                                    onClick={this.clickRecordMobile}
                                                >
                                                    {this.state.hasUploadedVideo == true ? (
                                                        <>
                                                            <FiRotateCcw /> Re-record
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FiVideo /> Record
                                                        </>
                                                    )}
                                                </Button>

                                                {this.state.hasUploadedVideo == true && (
                                                    <Box className="green">
                                                        <FiCheckCircle /> Video successfully uploaded
                                                    </Box>
                                                )}

                                                {this.state.uploadVideoError == true && (
                                                    <Box className="red">Error during uploading, please try again</Box>
                                                )}

                                                {this.state.isUploadingVideo == true && (
                                                    <div className="yellow">Uploading...</div>
                                                )}

                                                <input
                                                    id="video_file"
                                                    aria-labelledby={getElementLabel(this.props.data.id)}
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                    accept="video/*"
                                                    capture="user"
                                                    onInput={e => this.uploadFromIOS(e.target.files[0])}
                                                />
                                            </>
                                        ) : (
                                            <div id={this.videoWrapperId} className={'video-rec-wrapper'}>
                                                <div id={this.videoTimerId} className="video-rec-timer"></div>
                                                <div>
                                                    <video
                                                        id={this.videoRecorderId}
                                                        autoPlay
                                                        style={{
                                                            width: '100%',
                                                            height: '360px'
                                                        }}
                                                    />
                                                </div>
                                                <div id={this.videoControlsId} className="video-rec-controls">
                                                    <>
                                                        {this.state.hasRecordedVideo == true ? (
                                                            <>
                                                                {this.state.isUploadingVideo ? (
                                                                    <div className="yellow">Uploading...</div>
                                                                ) : (
                                                                    <>
                                                                        <Button
                                                                            variant="secondary"
                                                                            // Inline-end gap so the
                                                                            // button pair keeps its
                                                                            // spacing under RTL.
                                                                            sx={{
                                                                                marginInlineEnd: isMobile ? 0 : '16px'
                                                                            }}
                                                                            mb={isMobile ? 3 : 0}
                                                                            className="secondary-white"
                                                                            onClick={() => {
                                                                                if (
                                                                                    confirm(
                                                                                        'Delete recording and start over?'
                                                                                    )
                                                                                ) {
                                                                                    this.allowRecord();
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FiRotateCcw /> Re-record
                                                                        </Button>
                                                                        {this.state.uploadVideoError == true && (
                                                                            <Button
                                                                                variant="primary"
                                                                                mr={0}
                                                                                onClick={this.uploadVideoNotIos}
                                                                            >
                                                                                <FiUploadCloud /> Upload Video
                                                                            </Button>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {this.state.isRecordingVideo == true ? (
                                                                    <>
                                                                        <span className="red">
                                                                            {h ? h + 'hour' : ''} {m ? m + 'min' : ''}{' '}
                                                                            {s}sec remaining
                                                                        </span>
                                                                        {isMobile ? (
                                                                            <>
                                                                                <br />
                                                                                <br />
                                                                            </>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                        <Button
                                                                            variant="secondary"
                                                                            className="secondary-white"
                                                                            sx={{
                                                                                marginInlineStart: isMobile
                                                                                    ? 0
                                                                                    : '16px',
                                                                                marginInlineEnd: 0
                                                                            }}
                                                                            onClick={this.stopRecord}
                                                                        >
                                                                            <div className="recording-square"></div>{' '}
                                                                            Stop Recording
                                                                        </Button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {this.state.permissionAllowed == false && (
                                                                            <>
                                                                                <Button
                                                                                    variant="primary"
                                                                                    onClick={this.allowRecord}
                                                                                    mr={0}
                                                                                >
                                                                                    <FiMonitor /> Allow To Record
                                                                                </Button>
                                                                                <Box className="white fs-12" mt={3}>
                                                                                    We need <strong>temporary</strong>{' '}
                                                                                    permission to access your camera and
                                                                                    microphone to record your answer.
                                                                                    <br />
                                                                                    Please click <strong>
                                                                                        Allow
                                                                                    </strong>{' '}
                                                                                    when prompted by your browser.
                                                                                </Box>
                                                                            </>
                                                                        )}
                                                                        {this.state.permissionAllowed == true &&
                                                                            this.state.isCountingDown == false && (
                                                                                <Button
                                                                                    variant="secondary"
                                                                                    className="secondary-white"
                                                                                    onClick={this.startRecord}
                                                                                >
                                                                                    <div className="recording-circle"></div>{' '}
                                                                                    Start Recording
                                                                                </Button>
                                                                            )}
                                                                        {this.state.isCountingDown == true && (
                                                                            <div className="green">Get ready...</div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </>

                                                    {this.state.hasUploadedVideo == true && (
                                                        <Box className="green" mt={2}>
                                                            <FiCheckCircle /> Video successfully uploaded
                                                        </Box>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/*uploadProgressNum*/}

                                        <input
                                            aria-labelledby={getElementLabel(this.props.data.id)}
                                            hidden
                                            {...props}
                                        />
                                        <div className={SCREENER_QUESTION_ERRORS_CLASSNAME}></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            uploadProcessing: false,
            uploadComplete: false,
            uploadMaxFiles: false,
            fileStore: []
        };
        this.inputField = React.createRef();
        this.screenerFileUploadButton = this.screenerFileUploadButton.bind(this);
        this.cancelFileUpload = this.cancelFileUpload.bind(this);
        this.uploaded_files = [];
    }

    getAutocompleteAttribute() {
        //return 'name';
    }

    getAddPipeContainerId() {
        return this.props.data.id + '-fileupload-container';
    }

    componentDidMount() {}

    saveFileLink() {
        //document.getElementById(addPipeContainerId).value = link;
        console.log('setting value!!', this.uploaded_files);

        let new_value = [];
        this.uploaded_files.forEach(file => {
            new_value.push(file.remote_name);
        });

        this.inputField.current.value = new_value.length ? JSON.stringify(new_value) : null;
        console.log('this.inputField.current.value', this.inputField.current.value);
        if (this.props.handleChange) {
            this.props.handleChange();
        }
    }

    screenerFileUploadButton() {
        document.getElementById('s_file').click();
        document.getElementById('s_file').onchange = e => {
            this.setState({ uploadProcessing: true, uploadComplete: false });

            const file = e.target.files[0];

            this.getSignedUrl(file, signedUrlResponse => {
                var options = {
                    headers: {
                        'Content-Type': file.type
                    }
                };

                xhr.put(signedUrlResponse.signedUrl, file, options)
                    .then(ok => {
                        console.log('uploaded file', signedUrlResponse.fileName);

                        this.uploaded_files.push({
                            remote_name: signedUrlResponse.fileName,
                            original_name: file.name
                        });

                        this.setState(
                            {
                                uploadProcessing: false,
                                uploadComplete: true,
                                fileStore: this.uploaded_files
                            },
                            () => {
                                this.saveFileLink();
                            }
                        );
                        console.log('this.props.data.upload_files_cnt', this.props.data.upload_files_cnt);
                        if (
                            this.uploaded_files.length >= this.props.data.upload_files_cnt ||
                            this.props.data.upload_files_cnt === undefined
                        ) {
                            this.setState({
                                uploadMaxFiles: true
                            });
                        }
                    })
                    .catch(error => {
                        this.setState({
                            uploadProcessing: false
                        });

                        const errorText = services.parseAndTrackXhrErrors(error);

                        alert(errorText);
                    });
                console.log('ready to upload', signedUrlResponse);
            });

            //console.log(this.props.auth);

            /*

            const formData = new FormData();
            formData.append('s_file', file);

            xhr.post(`/screener-upload-file`, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                const s_file = response.data;
                this.saveFileLink(s_file);
                this.setState({
                    uploadProcessing: false,
                    uploadComplete: true
                });
            }).catch(error => {

                this.setState({
                    uploadProcessing: false
                });

                const errorText = services.parseAndTrackXhrErrors(error);

                alert(errorText);
            });*/
        };
    }

    cancelFileUpload(delete_remote_name) {
        const index = this.uploaded_files.forEach((file, index) => {
            if (file && file.remote_name == delete_remote_name) {
                this.uploaded_files.splice(index, 1);
            }
        });

        this.saveFileLink();

        this.setState({
            fileStore: this.uploaded_files,
            uploadMaxFiles: false
        });
    }

    getSignedUrl(file, callback) {
        if (file) {
            console.log('getting preseign file upload url');
            const file_extension = file.name ? file.name.split('.').pop() : '';
            services
                .getAwsSignedUrlForScreenerFile(file_extension)
                .then(response => {
                    //console.log(response);
                    callback(response);
                })
                .catch(error => {
                    alert('Upload error, please try again.');
                    this.setState({ uploadProcessing: false });
                    helpers.trackError(error);
                });
        } else {
            /*
            addToast('File not found', {
                appearance: 'error',
                autoDismiss: false
            });
            */
            //setBulkImportProcessing(false);
        }
    }

    render() {
        const props = {};
        props.type = 'text';
        props.className = 'form-control';
        props.name = this.props.data.field_name;
        if (this.props.mutable) {
            props.defaultValue = this.props.defaultValue;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        if (this.props.read_only || this.props.is_disabled) {
            props.disabled = 'disabled';
        }
        //console.log('this.props.read_only', this.props.read_only)
        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        //console.log('should_show', should_show)
        //console.log('textinput', this.props.data.label, should_show, this.props.all_questions)
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                {this.props.read_only ? (
                                    <>
                                        {this.props.defaultValue
                                            ? helpers.renderLinksForUploadedScreenerFile(this.props.defaultValue)
                                            : ''}
                                    </>
                                ) : (
                                    <Box mt={3}>
                                        {this.state.fileStore.length > 0 == true && (
                                            <Box mb={3} className="green medium">
                                                {this.state.fileStore.map((file, idx) => {
                                                    return (
                                                        <div className="upload-file__wrapper" key={idx}>
                                                            <span>
                                                                <FiCheckCircle
                                                                    style={{
                                                                        verticalAlign: 'top',
                                                                        marginTop: '4px',
                                                                        // Gap sits between the tick
                                                                        // and the filename that
                                                                        // follows it, either way round.
                                                                        marginInlineEnd: '4px'
                                                                    }}
                                                                />
                                                                {file.original_name}
                                                            </span>
                                                            <span>
                                                                <button
                                                                    onClick={() =>
                                                                        this.cancelFileUpload(file.remote_name)
                                                                    }
                                                                >
                                                                    <FiTrash2 style={{ color: 'red' }} />
                                                                </button>
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </Box>
                                        )}
                                        {this.state.uploadMaxFiles ? null : (
                                            <Button
                                                type="button"
                                                variant={
                                                    this.state.uploadComplete == true ? 'secondary-gray' : 'primary'
                                                }
                                                onClick={this.screenerFileUploadButton}
                                                disabled={this.state.uploadProcessing}
                                                sx={{ marginInlineEnd: '8px' }}
                                            >
                                                {this.state.uploadProcessing ? (
                                                    'Uploading...'
                                                ) : (
                                                    <>
                                                        <FiUploadCloud /> Upload file
                                                    </>
                                                )}
                                            </Button>
                                        )}
                                        <Box mt={2}>Max file size is 10MB.</Box>
                                        <input
                                            aria-labelledby={getElementLabel(this.props.data.id)}
                                            type="file"
                                            id="s_file"
                                            hidden
                                        />
                                        <input
                                            aria-labelledby={getElementLabel(this.props.data.id)}
                                            hidden
                                            {...props}
                                        />

                                        <div className={SCREENER_QUESTION_ERRORS_CLASSNAME}></div>
                                    </Box>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class HiddenValue extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();

        //console.log(props)
        this.state = {
            value: props.defaultValue !== undefined ? props.defaultValue : props.data.default_value
        };
    }

    getAutocompleteAttribute() {
        //return 'name';
    }

    render() {
        const props = {};
        props.type = 'hidden';
        props.className = 'form-control';
        props.name = this.props.data.field_name;
        if (this.props.mutable) {
            //props.defaultValue = this.props.defaultValue;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        if (this.props.read_only || this.props.is_disabled) {
            props.disabled = 'disabled';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        //console.log('should_show', should_show)
        //console.log('textinput', this.props.data.label, should_show, this.props.all_questions)
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses} style={{ padding: 0, border: 0 }}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <Input
                                    {...props}
                                    required={this.props.data.required}
                                    value={this.state.value}
                                    onChange={e => {
                                        this.setState({ value: e.target.value });
                                        if (this.props.handleChange) {
                                            this.props.handleChange();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class TextInput extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
    }

    getAutocompleteAttribute() {
        //return 'name';
    }

    render() {
        const props = {};
        props.type = 'text';
        props.className = 'form-control';
        props.name = this.props.data.field_name;
        if (this.props.mutable) {
            props.defaultValue = this.props.defaultValue;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        if (this.props.read_only || this.props.is_disabled) {
            props.disabled = 'disabled';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        //console.log('should_show', should_show)
        //console.log('textinput', this.props.data.label, should_show, this.props.all_questions)
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                <Input
                                    mt={this.props.isPopup ? undefined : 3}
                                    {...props}
                                    aria-labelledby={getElementLabel(this.props.data.id)}
                                    placeholder="Your answer"
                                    required={this.props.data.required}
                                    autoComplete={this.getAutocompleteAttribute()}
                                    onChange={e => {
                                        if (this.props.handleChange) {
                                            this.props.handleChange(e);
                                        }
                                    }}
                                />
                                <div className={SCREENER_QUESTION_ERRORS_CLASSNAME}></div>
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class NumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
    }

    render() {
        const props = {};
        props.className = 'form-control';
        props.name = this.props.data.field_name;

        if (this.props.mutable) {
            props.defaultValue = this.props.defaultValue;
            props.ref = this.inputField;
        }

        if (this.props.read_only) {
            props.disabled = 'disabled';
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        console.log('should_show NUMBER', should_show);
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                <Input
                                    type="number"
                                    aria-labelledby={getElementLabel(this.props.data.id)}
                                    mt={this.props.isPopup ? '4px' : 3}
                                    {...props}
                                    onChange={e => {
                                        //console.log('changing??')
                                        if (this.props.handleChange) {
                                            this.props.handleChange(e);
                                        }
                                    }}
                                />
                                <div className={SCREENER_QUESTION_ERRORS_CLASSNAME}></div>
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
    }

    render() {
        const props = {};
        props.className = 'form-control';
        props.name = this.props.data.field_name;

        if (this.props.read_only) {
            props.disabled = 'disabled';
        }

        if (this.props.mutable) {
            props.defaultValue = this.props.defaultValue;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                <TextAreaAutosize
                                    {...props}
                                    type="text"
                                    aria-labelledby={getElementLabel(this.props.data.id)}
                                    style={{ width: '100%', marginTop: this.props.isPopup ? '4px' : '8px' }}
                                    minRows={4}
                                    className="theme-input"
                                    placeholder="Your answer"
                                    onChange={e => {
                                        if (this.props.handleChange) {
                                            this.props.handleChange(e);
                                        }
                                    }}
                                />
                                <div className={SCREENER_QUESTION_ERRORS_CLASSNAME}></div>
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        // Hidden <input> the parent <form> reads via
        // `ReactDOM.findDOMNode(ref.inputField.current).value` (see
        // form.jsx _getItemValue). The visible UI is a searchable Combobox
        // that mirrors its selection into this input.
        this.inputField = React.createRef();
        this.state = { value: props.defaultValue || '' };
        this.handleComboboxChange = this.handleComboboxChange.bind(this);
    }

    handleComboboxChange(value) {
        this.setState({ value });
        if (this.inputField.current) {
            this.inputField.current.value = value;
        }
        if (this.props.handleChange) {
            this.props.handleChange({ target: this.inputField.current });
        }
    }

    render() {
        const fieldName = this.props.data.field_name;

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        const should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );

        if (!(should_show || this.props.editElement || this.props.read_only)) {
            return null;
        }

        const all_options = helpersScreener.getOriginalAndPipedAnswerOptions(
            this.props.data,
            this.props.all_questions,
            this.props.answers_by_form_element_name
        );

        const items = all_options.map(option => {
            const piped = helpersScreener.insertPiping(
                option.text,
                this.props.all_questions,
                this.props.answers_by_form_element_name
            );
            const showQualification =
                option.hasOwnProperty('qualification') && (this.props.read_only || this.props.show_qualification);
            // Normalize value to string (preserving 0/false) so numeric values match string currentValue
            const normalizedValue = option.value === null || option.value === undefined ? '' : String(option.value);
            return {
                value: normalizedValue,
                label: showQualification ? `${piped} [${option.qualification}]` : piped
            };
        });

        // Prepend clearable entry unless in read-only mode
        if (!this.props.read_only) {
            items.unshift({ value: '', label: 'Choose' });
        }

        // Normalize currentValue to string for consistent comparison with items
        const rawValue = this.props.read_only ? this.props.defaultValue || '' : this.state.value;
        const currentValue = rawValue === null || rawValue === undefined ? '' : String(rawValue);
        const labelId = getElementLabel(this.props.data.id);

        return (
            <div className={baseClasses}>
                {this.props.editElement ? (
                    this.props.editElement
                ) : (
                    <div>
                        <ComponentHeader {...this.props} />
                        <div className="form-group">
                            <ComponentLabel
                                {...this.props}
                                isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                            />
                            <input ref={this.inputField} type="hidden" name={fieldName} value={currentValue} readOnly />
                            <Combobox
                                items={items}
                                value={currentValue}
                                onChange={this.props.read_only ? () => {} : this.handleComboboxChange}
                                ariaLabelledBy={labelId}
                                style={{ maxWidth: '100%', opacity: this.props.read_only ? 0.6 : 1 }}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

class Signature extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: props.defaultValue,
            prevPropDefaultValue: props.defaultValue, // Track prop changes
            typedText: '',
            isUploading: false,
            uploadError: false,
            hasUploadedSignature: !!props.defaultValue
        };
        this.inputField = React.createRef();
        this.canvas = React.createRef();
        this.uploadSignature = this.uploadSignature.bind(this);

        // Calculate canvas dimensions once and freeze them to prevent canvas clearing on resize
        // Canvas content is lost when dimensions change, so we keep them stable
        // Cap mobile width at 600 to ensure it fits portrait while allowing reasonable landscape width
        const mobileWidth = Math.min(window.innerWidth - 32 * 2 - 24 * 2, 600);
        this.canvasWidth = isMobile ? mobileWidth : 600;
        this.canvasHeight = 200;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        // Update state when defaultValue prop changes (e.g., admin editing signature)
        // Compare against prevPropDefaultValue to detect actual prop changes (not state changes)
        if (nextProps.defaultValue !== prevState.prevPropDefaultValue) {
            return {
                defaultValue: nextProps.defaultValue,
                prevPropDefaultValue: nextProps.defaultValue,
                hasUploadedSignature: !!nextProps.defaultValue
            };
        }
        return null;
    }

    clear = () => {
        if (this.state.defaultValue) {
            this.setState({ defaultValue: '', typedText: '', hasUploadedSignature: false });
        } else if (this.canvas.current) {
            this.canvas.current.clear();
            this.setState({ typedText: '', hasUploadedSignature: false });
        }
        if (this.inputField.current) {
            this.inputField.current.value = '';
        }
    };

    async uploadSignature() {
        if (!this.canvas.current || !this.props.mutable) {
            return;
        }

        const canvas = this.canvas.current.getCanvas();
        if (!canvas || this.canvas.current.isEmpty()) {
            return;
        }

        this.setState({ isUploading: true, uploadError: false });

        try {
            // Upload signature canvas to S3
            const s3Path = await services.uploadSignatureCanvasToS3(canvas);

            // Store the S3 path in state (controlled input will sync automatically)
            this.setState(
                {
                    isUploading: false,
                    defaultValue: s3Path,
                    hasUploadedSignature: true
                },
                () => {
                    // Update form state with the S3 path
                    if (this.props.handleChange) {
                        this.props.handleChange();
                    }
                }
            );
        } catch (error) {
            this.setState({ isUploading: false, uploadError: true });
            helpers.trackError(error);
            throw error; // Re-throw so form submission can catch it
        }
    }

    handleKeyDown = e => {
        if (!this.props.mutable) return;

        e.persist();

        if (e.key === 'Backspace') {
            this.setState(
                prevState => ({ typedText: prevState.typedText.slice(0, -1) }),
                () => this.drawText()
            );
        } else if (e.key === ' ') {
            e.preventDefault();
            this.setState(
                prevState => ({ typedText: prevState.typedText + ' ' }),
                () => this.drawText()
            );
        } else if (e.key.length === 1) {
            this.setState(
                prevState => ({ typedText: prevState.typedText + e.key }),
                () => this.drawText()
            );
        }
    };

    drawText = () => {
        const canvas = this.canvas.current && this.canvas.current.getCanvas();
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '48px cursive';
        ctx.fillStyle = this.props.penColor || 'black';
        ctx.fillText(this.state.typedText, 20, 60);

        // Update isEmpty based on actual content to prevent blank signatures
        // This fixes validation bypass where typing then backspacing left isEmpty=false
        if (this.state.typedText.trim().length > 0) {
            this.canvas.current._sigPad._isEmpty = false;
        } else {
            this.canvas.current._sigPad._isEmpty = true;
        }
    };

    render() {
        const { defaultValue, typedText, hasUploadedSignature } = this.state;
        let canClear = !!defaultValue || typedText.length > 0;
        const props = { type: 'hidden', name: this.props.data.field_name };

        if (this.props.mutable) {
            // Always use controlled input to ensure value stays in sync with state
            // This prevents stale values when getDerivedStateFromProps updates defaultValue
            props.value = defaultValue || '';
            props.onChange = () => {}; // Prevent React warning for controlled input
            props.ref = this.inputField;
        }

        const pad_props = {
            backgroundColor: '#fff',
            canvasProps: {
                // Use stored dimensions to prevent canvas clearing on re-renders
                width: this.canvasWidth,
                height: this.canvasHeight,
                tabIndex: 0,
                onKeyDown: this.handleKeyDown,
                'aria-labelledby': getElementLabel(this.props.data.id),
                'aria-describedby': 'signature-instructions'
            }
        };

        if (this.props.mutable) {
            pad_props.defaultValue = defaultValue;
            pad_props.ref = this.canvas;
            canClear = !this.props.read_only;
            const parent_props = this.props;
            pad_props.onEnd = () => {
                if (parent_props.handleChange) {
                    parent_props.handleChange();
                }
            };
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        const sourceDataURL = helpersScreener.getSignatureUrl(defaultValue);

        const signatureLineCss = {
            position: 'absolute',
            bottom: '32px',
            right: '32px',
            left: '32px',
            height: '1px',
            borderTop: '1px dashed #606E85'
        };

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );

        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                {this.props.read_only === true || (hasUploadedSignature && !!sourceDataURL) ? (
                                    <img src={sourceDataURL} />
                                ) : (
                                    <span
                                        className={'border rounded inline-block relative'}
                                        style={{ overflow: 'hidden', maxWidth: '100%' }}
                                    >
                                        <SignaturePad {...pad_props} />
                                        <div style={signatureLineCss}></div>
                                        <div
                                            aria-live="assertive"
                                            style={{ overflow: 'hidden', maxHeight: 0, maxWidth: 0 }}
                                        >
                                            {typedText}
                                        </div>
                                    </span>
                                )}
                                <Box mt={3}>
                                    {canClear && (
                                        <Button type="button" variant="secondary-gray" onClick={this.clear}>
                                            {hasUploadedSignature ? 'Re-sign' : 'Clear Signature'}
                                        </Button>
                                    )}
                                    {this.state.isUploading && (
                                        <Box className="yellow" mt={2}>
                                            Uploading signature...
                                        </Box>
                                    )}
                                    {this.state.uploadError && (
                                        <Box className="red" mt={2}>
                                            Error uploading signature, please try again
                                        </Box>
                                    )}
                                    {hasUploadedSignature && !this.state.isUploading && (
                                        <Box className="green" mt={2}>
                                            ✓ Signature saved
                                        </Box>
                                    )}
                                </Box>
                                <p style={{ visibility: 'hidden' }} id="signature-instructions">
                                    Use your mouse or keyboard to sign. Press backspace to clear.
                                </p>
                                <input {...props} />
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class Tags extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
        const { defaultValue, data } = props;
        this.state = { value: this.getDefaultValue(defaultValue, data.options) };
    }

    getDefaultValue(defaultValue, options) {
        if (defaultValue) {
            if (typeof defaultValue === 'string') {
                const vals = defaultValue.split(',').map(x => x.trim());
                return options.filter(x => vals.indexOf(x.value) > -1);
            }
            return options.filter(x => defaultValue.indexOf(x.value) > -1);
        }
        return [];
    }

    // state = { value: this.props.defaultValue !== undefined ? this.props.defaultValue.split(',') : [] };

    handleChange = e => {
        this.setState({ value: e });
    };

    render() {
        const options = this.props.data.options.map(option => {
            option.label = option.text;
            return option;
        });
        const props = {};
        props.isMulti = true;
        props.name = this.props.data.field_name;
        props.onChange = this.handleChange;

        props.options = options;
        if (!this.props.mutable) {
            props.value = options[0].text;
        } // to show a sample of what tags looks like
        if (this.props.mutable) {
            props.isDisabled = this.props.read_only;
            props.value = this.state.value;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                <Select {...props} />
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class Checkboxes extends React.Component {
    constructor(props) {
        super(props);
        this.options = {};
        this.lastOptionsProp = null;
        this.isNoneOfTheAboveRef = React.createRef();
    }

    /**
     * Generate option key
     *
     * @param {string} optionKey - option key
     * @returns {string}
     */
    generateOptionKey(optionKey) {
        return `option_${optionKey}`;
    }

    /**
     * Generate ref key
     *
     * @param {string} optionKey - option key
     * @returns {string} - ref key
     */
    generateRefKey(optionKey) {
        return `child_ref_${optionKey}`;
    }

    getElementIdFromParentProps(parentProps) {
        return parentProps && parentProps.data && parentProps.data.id ? parentProps.data.id : '';
    }

    /**
     * Get none of the above option
     *
     * @returns {any}
     */
    getNoneOfTheAboveOption() {
        return this.props.data.options.find(option => option.is_none_of_the_above);
    }

    /**
     * Clear all options if none of the above is checked
     */
    clearAboveOptions() {
        const noneOfTheAboveOption = this.getNoneOfTheAboveOption();

        if (!noneOfTheAboveOption) return;

        const noneOfTheAboveOptionRefKey = this.generateRefKey(noneOfTheAboveOption.key);

        // clear all other options
        Object.keys(this.options).forEach(optionRefKey => {
            if (optionRefKey !== noneOfTheAboveOptionRefKey) {
                this.options[optionRefKey].checked = false;
            }
        });
    }

    /**
     * Clear none of the above option if any other option is checked
     */
    clearNoneOfTheAbove() {
        const noneOfTheAboveOption = this.getNoneOfTheAboveOption();

        if (!noneOfTheAboveOption) return;

        const noneOfTheAboveOptionRefKey = this.generateRefKey(noneOfTheAboveOption.key);
        const noneOfTheAboveOptionRef = this.options[noneOfTheAboveOptionRefKey];

        // if none of the above is checked and any other option is checked, uncheck none of the above
        if (!noneOfTheAboveOptionRef || !noneOfTheAboveOptionRef.checked || this.checkedCount === 0) return;

        // uncheck none of the above
        noneOfTheAboveOptionRef.checked = false;
    }

    /**
     * Get a value that checks if the question has a "None of the above" option
     * Function memorizes the result to avoid unnecessary re-calculations
     *
     * @returns {boolean} - true if the question has a "None of the above" option
     */
    get isNoneOfTheAbove() {
        if (this.isNoneOfTheAboveRef.current == null || !isEqual(this.props.data.options, this.lastOptionsProp)) {
            this.isNoneOfTheAboveRef.current = !!this.getNoneOfTheAboveOption();
            this.lastOptionsProp = this.props.data.options;
        }

        return this.isNoneOfTheAboveRef.current;
    }

    /**
     * Updates the inner content of all elements that follow a specific data attribute
     * based on the value of the event target.
     *
     * @param {string} addOtherName The name of the add other input element
     * @param {Object} event The event object triggered, expected to contain a target with a value.
     * @return {void} Does not return a value.
     */
    updateOptionFollowers(addOtherName, event) {
        const followers = document.querySelectorAll(`[data-follow="${addOtherName}"]`);

        if (followers.length > 0) {
            followers.forEach(follower => {
                follower.innerHTML = event.target.value;
            });
        }
    }

    renderOptions(parentProps) {
        let classNames = 'custom-control custom-checkbox';
        if (parentProps.data.inline) {
            classNames += ' option-inline';
        }

        const numColumns = parentProps.data.num_columns ? parentProps.data.num_columns : 1;
        let elements = [];

        let all_options = helpersScreener.getOriginalAndPipedAnswerOptions(
            parentProps.data,
            parentProps.all_questions,
            parentProps.answers_by_form_element_name
        );

        all_options.forEach(option => {
            const inputId = helpersScreener.generateRadioCheckboxInputId(this.props.data.id, option.key);
            const props = {};
            props.name = this.generateOptionKey(option.key);
            props.type = 'checkbox';
            props.value = option.value;

            if (parentProps.mutable) {
                props.defaultChecked = false;

                let defaultValueArray = [];
                if (helpers.isJsonString(parentProps.defaultValue)) {
                    defaultValueArray = JSON.parse(parentProps.defaultValue);
                } else if (Array.isArray(parentProps.defaultValue)) {
                    defaultValueArray = parentProps.defaultValue;
                }

                if (
                    defaultValueArray !== undefined &&
                    Array.isArray(defaultValueArray) &&
                    defaultValueArray.indexOf(option.key) > -1
                ) {
                    props.defaultChecked = true;
                } else if (
                    defaultValueArray !== undefined &&
                    Array.isArray(defaultValueArray) &&
                    defaultValueArray.indexOf(option.value) > -1
                ) {
                    props.defaultChecked = true;
                }
            }
            if (this.props.read_only) {
                props.disabled = 'disabled';
            }

            let element_add_other;
            let props_add_other = {};
            if (option.is_add_other) {
                props_add_other = {
                    name: helpersScreener.generateInputKey(option.key),
                    type: 'input',
                    value: parentProps.defaultValueOther
                };

                if (this.props.read_only) {
                    props_add_other.disabled = 'disabled';
                }

                element_add_other = (
                    <Box>
                        <label htmlFor={inputId}>
                            <div>
                                {parentProps.data.other_specify_label ? (
                                    <div style={{ marginBottom: '4px' }}>{parentProps.data.other_specify_label}</div>
                                ) : (
                                    ''
                                )}
                            </div>
                            <Input
                                width={200}
                                {...props_add_other}
                                aria-labelledby={getElementLabel(parentProps.data.id)}
                                onChange={event => this.updateOptionFollowers(props_add_other.name, event)}
                                placeholder=""
                                onClick={() => {
                                    // when user clicks on the input of OTHER, make sure to checkmark the value
                                    const els = document.getElementsByName(props.name);
                                    if (els.length == 1) {
                                        const el = els[0];
                                        if (!el.checked) {
                                            el.click();
                                        }
                                    }
                                }}
                            />
                        </label>{' '}
                    </Box>
                );
            }

            let element_none_of_the_above;
            if (option.is_none_of_the_above) {
                element_none_of_the_above = (
                    <label className="custom-control-label" htmlFor={inputId}>
                        {parentProps.data.none_above_specify_label || 'None of the above'}

                        {option.hasOwnProperty('qualification') &&
                        this.props.show_qualification &&
                        option.qualification ? (
                            <Badge size="sm" style={{ marginInlineStart: '12px' }} type="warn">
                                {option.qualification}
                            </Badge>
                        ) : null}
                    </label>
                );
            }

            elements.push(
                <Flex key={inputId} sx={{ gridGap: 2 }} mt={1} fontSize={2} className={classNames}>
                    <Box
                        sx={{
                            width: '16px',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'start',
                            marginTop: '6px'
                        }}
                    >
                        <input
                            id={inputId}
                            className={`custom-control-input ${this.getElementIdFromParentProps(parentProps)}`}
                            ref={c => {
                                if (c && parentProps.mutable) {
                                    const refKey = this.generateRefKey(option.key);

                                    if (!this.options[refKey]) {
                                        // NOTE: We can't assign it to a reference, because some logic outside this component must access it
                                        this.options[refKey] = c;
                                    }
                                }
                            }}
                            onChange={e => {
                                // When none of the above is set we want to add extra logic to improve UX
                                if (this.isNoneOfTheAbove) {
                                    if (option.is_none_of_the_above && e.target.checked) {
                                        this.clearAboveOptions();
                                    } else {
                                        this.clearNoneOfTheAbove();
                                    }
                                }

                                if (this.props.handleChange) {
                                    this.props.handleChange(e);
                                }
                            }}
                            {...props}
                        />
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        {isNonStandardOption(option) ? (
                            renderNonStandardOption(option, element_add_other, element_none_of_the_above)
                        ) : (
                            <>
                                <label className="custom-control-label" htmlFor={inputId}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: helpersScreener.insertPiping(
                                                option.text,
                                                this.props.all_questions,
                                                this.props.answers_by_form_element_name
                                            )
                                        }}
                                        data-follow={option.follow}
                                        className="option-label__tag"
                                    ></div>
                                    {option.hasOwnProperty('qualification') &&
                                    this.props.show_qualification &&
                                    option.qualification ? (
                                        <Badge size="sm" style={{ marginInlineStart: '12px' }} type="warn">
                                            {option.qualification}
                                        </Badge>
                                    ) : null}
                                </label>
                            </>
                        )}
                        {option.image && (
                            <label htmlFor={inputId}>
                                <img src={option.image} style={{ maxWidth: '320px' }} />
                            </label>
                        )}
                    </Box>
                </Flex>
            );
        });

        return (
            <div
                role="group"
                aria-labelledby={getElementLabel(this.props.data.id)}
                style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
                    alignItems: 'start',
                    gap: '16px',
                    margin: 0,
                    padding: 0
                }}
            >
                {elements}
            </div>
        );
    }

    /**
     * Get the number of checked options
     *
     * @returns {number}
     */
    get checkedCount() {
        return Object.keys(this.options).filter(key => this.options[key].checked).length;
    }

    /**
     * Get error message based on validation rules
     */
    get errorMessage() {
        if (!this.props.data.validation || !this.props.data.validation_rules) return null;

        // Don't display an error if checkboxes are not touched
        if (this.checkedCount === 0) return null;

        for (const rule of this.props.data.validation_rules) {
            if (rule.validation_type === VALIDATION_MINIMUM && this.checkedCount < rule.validation_value) {
                return rule.validation_message || `Please select at least ${rule.validation_value} options.`;
            }

            if (rule.validation_type === VALIDATION_MAXIMUM && this.checkedCount > rule.validation_value) {
                return rule.validation_message || `Please select at most ${rule.validation_value} options.`;
            }

            if (rule.validation_type === VALIDATION_EXACT && this.checkedCount !== +rule.validation_value) {
                return rule.validation_message || `Please select exactly ${rule.validation_value} options.`;
            }

            // If no validation type is set, we assume that exactly one option should be selected
            // Check out: validation_types.push({ title: 'Select One', value: '' });
            if (rule.validation_type === '' && this.checkedCount !== 1) {
                return 'Please select exactly 1 option.';
            }
        }

        return null;
    }

    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );

        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                {this.renderOptions(this.props)}
                                {this.errorMessage && (
                                    <Badge style={{ marginTop: '16px' }} type="danger">
                                        <FiAlertCircle /> {this.errorMessage}
                                    </Badge>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

const matrixLabelAccessabilityStyles = {
    visibility: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0
};

class Matrix extends React.Component {
    constructor(props) {
        super(props);
        this.options = {};
    }

    getOptionId(this_key, column_key) {
        return this_key + '_' + column_key;
    }

    /**
     * Row keys are not unique per question: piped rows keep the source question's
     * option keys, so every matrix piped from the same question shares them.
     * Anything that must be unique in the document is scoped by the field name.
     *
     * @param {string} row_key - row option key
     * @returns {string} - name of the row's radio group
     */
    getRowInputName(row_key) {
        return `option_${this.props.data.field_name}_${row_key}`;
    }

    /**
     * @param {string} row_key - row option key
     * @returns {string} - DOM id of the row header
     */
    getRowHeaderId(row_key) {
        return `${this.props.data.field_name}_${row_key}`;
    }

    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let all_options = helpersScreener.getOriginalAndPipedAnswerOptions(
            this.props.data,
            this.props.all_questions,
            this.props.answers_by_form_element_name
        );

        const rows = all_options.filter(o => o.type === 'row');
        const columns = all_options.filter(o => o.type === 'column');

        const matrixType = helpersScreener.getMatrixType(this.props.data);

        const should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );

        if (!should_show && !this.props.editElement && !this.props.read_only) return null;

        if (this.props.editElement) {
            return <div className={baseClasses}>{this.props.editElement}</div>;
        }

        return (
            <div className={baseClasses}>
                <ComponentHeader {...this.props} />
                <div className="matrix-container">
                    <ComponentLabel
                        {...this.props}
                        isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                    />
                    <div style={{ width: '100%', overflowY: 'auto' }}>
                        <table className={matrixStyles.matrix}>
                            <thead>
                                <tr
                                    className={classNames(matrixStyles.backgroundWhite)}
                                    style={{
                                        visibility: isMobile ? 'collapse' : undefined
                                    }}
                                >
                                    <th
                                        scope="col"
                                        className={classNames(matrixStyles.stickyColumn, matrixStyles.backgroundWhite)}
                                    ></th>
                                    {columns.map(column => (
                                        <th key={column.key} id={column.key} scope="col">
                                            {helpersScreener.insertPiping(
                                                column.text,
                                                this.props.all_questions,
                                                this.props.answers_by_form_element_name
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr
                                        key={row.key}
                                        role={matrixType === 'radio' ? 'radiogroup' : 'group'}
                                        aria-labelledby={this.getRowHeaderId(row.key)}
                                        className={classNames(
                                            index % 2 === 0 ? matrixStyles.backgroundGrey : matrixStyles.backgroundWhite
                                        )}
                                    >
                                        <th
                                            scope="row"
                                            id={this.getRowHeaderId(row.key)}
                                            className={classNames(
                                                matrixStyles.stickyColumn,
                                                index % 2 === 0
                                                    ? matrixStyles.backgroundGrey
                                                    : matrixStyles.backgroundWhite
                                            )}
                                            data-follow={row.follow}
                                        >
                                            {helpersScreener.insertPiping(
                                                row.text,
                                                this.props.all_questions,
                                                this.props.answers_by_form_element_name
                                            )}
                                        </th>
                                        {columns.map(column => {
                                            const optionId = this.getOptionId(row.key, column.key);
                                            const inputProps = {
                                                name: this.getRowInputName(row.key),
                                                type: matrixType
                                            };

                                            if (this.props.mutable) {
                                                inputProps.defaultChecked =
                                                    this.props.defaultValue !== undefined &&
                                                    this.props.defaultValue.indexOf(row.key + '_' + column.key) > -1;
                                            }

                                            if (this.props.read_only) {
                                                inputProps.disabled = 'disabled';
                                            }

                                            if (inputProps.type === 'text') {
                                                const foundTextAnswer = this.props.defaultValue.find?.(
                                                    kv => kv.key === optionId
                                                );

                                                if (foundTextAnswer) {
                                                    inputProps.defaultValue = foundTextAnswer.value;
                                                }
                                            }

                                            const inputLabel = (
                                                <label htmlFor={optionId}>
                                                    {helpersScreener.insertPiping(
                                                        column.text,
                                                        this.props.all_questions,
                                                        this.props.answers_by_form_element_name
                                                    )}
                                                </label>
                                            );

                                            return (
                                                <td key={column.key}>
                                                    <div
                                                        className={matrixStyles.cell}
                                                        style={{
                                                            flexDirection: inputProps.type === 'text' ? 'column' : 'row'
                                                        }}
                                                    >
                                                        {inputProps.type === 'text' && isMobile && inputLabel}
                                                        <input
                                                            id={optionId}
                                                            aria-labelledby={!isMobile ? column.key : undefined}
                                                            ref={ref => {
                                                                if (ref && this.props.mutable) {
                                                                    this.options[
                                                                        `child_ref_${row.key}_${column.key}`
                                                                    ] = ref;
                                                                }
                                                            }}
                                                            onChange={e =>
                                                                this.props.handleChange && this.props.handleChange(e)
                                                            }
                                                            style={{ cursor: 'pointer' }}
                                                            className={classNames(
                                                                inputProps.type === 'text' && 'theme-input'
                                                            )}
                                                            {...inputProps}
                                                        />
                                                        {inputProps.type !== 'text' && isMobile && inputLabel}
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div role="alert" aria-live="assertive" className={SCREENER_QUESTION_ERRORS_CLASSNAME} />
                </div>
            </div>
        );
    }
}

class RadioButtons extends React.Component {
    constructor(props) {
        super(props);
        this.options = {};
    }

    /**
     * Updates the inner content of all elements that follow a specific data attribute
     * based on the value of the event target.
     *
     * @param {string} addOtherName The name of the add other input element
     * @param {Object} event The event object triggered, expected to contain a target with a value.
     * @return {void} Does not return a value.
     */
    updateOptionFollowers(addOtherName, event) {
        const followers = document.querySelectorAll(`[data-follow="${addOtherName}"]`);

        if (followers.length > 0) {
            followers.forEach(follower => {
                follower.innerHTML = event.target.value;
            });
        }
    }

    renderOptions(parentProps) {
        let classNames = 'custom-control custom-radio fs-body-16';
        if (this.props.data.inline) {
            classNames += ' option-inline';
        }

        const numColumns = parentProps.data.num_columns ? parentProps.data.num_columns : 1;
        const elements = [];

        const allOptions = helpersScreener.getOriginalAndPipedAnswerOptions(
            parentProps.data,
            parentProps.all_questions,
            parentProps.answers_by_form_element_name
        );

        allOptions.forEach(option => {
            const inputId = helpersScreener.generateRadioCheckboxInputId(this.props.data.id, option.key);
            const props = {
                name: this.props.data.field_name,
                type: 'radio',
                value: option.value
            };

            if (this.props.mutable) {
                props.defaultChecked =
                    this.props.defaultValue !== undefined &&
                    (this.props.defaultValue.indexOf(option.key) > -1 ||
                        this.props.defaultValue.indexOf(option.value) > -1);
            }

            if (parentProps.read_only) {
                props.disabled = 'disabled';
            }

            let propsAddOther = {};
            if (option.is_add_other) {
                propsAddOther = {
                    name: helpersScreener.generateInputKey(option.key),
                    type: 'input',
                    value: this.props.defaultValueOther
                };

                if (parentProps.read_only) {
                    propsAddOther.disabled = 'disabled';
                }
            }

            const shouldShowLogic = parentProps.show_qualification && option?.qualification;

            elements.push(
                <label
                    htmlFor={inputId}
                    style={{ display: 'flex', alignItems: 'stretch', gap: '12px' }}
                    className={classNames}
                    key={inputId}
                >
                    <div
                        style={{
                            paddingTop: '4px',
                            position: 'relative'
                        }}
                    >
                        <input
                            id={inputId}
                            className="custom-control-input"
                            ref={c => {
                                if (c && this.props.mutable) {
                                    this.options[`child_ref_${option.key}`] = c;
                                }
                            }}
                            onChange={e => {
                                if (parentProps.handleChange) {
                                    parentProps.handleChange(e);
                                }
                            }}
                            style={{ width: '13px', height: '13px' }}
                            {...props}
                        />
                        {shouldShowLogic && (
                            <svg
                                width="100%"
                                viewBox="0 0 15 38"
                                preserveAspectRatio="none"
                                // The path runs down from the radio then elbows *towards* the
                                // qualification badge, so it is inherently directional. The
                                // inset follows the reading direction here; rtl.css mirrors
                                // the path itself via this class.
                                className="option-logic-elbow"
                                style={{
                                    display: 'block',
                                    height: 'calc(100% - 10px - 4px - 13px - 7px)', // full - half of badge - top padding - radio height - badge margin
                                    position: 'absolute',
                                    insetInlineStart: 'calc(50% - 1px)',
                                    top: 4 + 13 + 7 // top padding + radio height + badge margin
                                }}
                            >
                                <path
                                    d="M1 1 L 1 33 C1 35.2091 2.79086 37 5 37 L 15 37"
                                    stroke="#D4D9DD"
                                    strokeWidth={1}
                                    fill="none"
                                    vectorEffect="non-scaling-stroke"
                                />
                            </svg>
                        )}
                    </div>
                    <div>
                        {option.is_add_other ? (
                            <span>
                                <div>
                                    {parentProps.data.other_specify_label ? (
                                        <div style={{ marginBottom: '4px' }}>
                                            {parentProps.data.other_specify_label}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <Input
                                    width={160}
                                    {...propsAddOther}
                                    aria-labelledby={getElementLabel(parentProps.data.id)}
                                    placeholder=""
                                    onClick={() => {
                                        // when user clicks on the input of OTHER, make sure to checkmark the value
                                        const el = document.getElementById(inputId);
                                        if (el) {
                                            el.click();
                                        }
                                    }}
                                    onChange={event => this.updateOptionFollowers(propsAddOther.name, event)}
                                />
                            </span>
                        ) : (
                            <span className="custom-control-label">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: helpersScreener.insertPiping(
                                            option.text,
                                            parentProps.all_questions,
                                            parentProps.answers_by_form_element_name
                                        )
                                    }}
                                    className="option-label__tag"
                                    data-follow={option.follow}
                                ></div>
                            </span>
                        )}
                        {option.image && <img src={option.image} style={{ maxWidth: '320px' }} />}
                        {shouldShowLogic && (
                            <Badge size="sm" type="warn" style={{ marginTop: '12px' }}>
                                {option.qualification}
                            </Badge>
                        )}
                    </div>
                </label>
            );
        });

        return (
            <div
                role="radiogroup"
                aria-label={parentProps.data.label}
                style={{ margin: 0, padding: 0, border: 'none', width: '100%' }}
            >
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
                        alignItems: 'start',
                        gap: '16px'
                    }}
                >
                    {elements}
                </div>
            </div>
        );
    }

    render() {
        const baseClasses = 'SortableItem rfb-item' + (this.props.data.pageBreakBefore ? ' alwaysbreak' : '');

        const should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );

        if (!should_show && !this.props.editElement && !this.props.read_only) {
            return null;
        }

        if (this.props.editElement) return <div className={baseClasses}>{this.props.editElement}</div>;

        return (
            <div className={baseClasses}>
                <div>
                    <ComponentHeader {...this.props} />
                    <div className="form-group">
                        <ComponentLabel
                            {...this.props}
                            isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                        />
                        <Flex style={{ width: '100%', flexWrap: 'wrap' }}>{this.renderOptions(this.props)}</Flex>
                    </div>
                </div>
            </div>
        );
    }
}

class Image extends React.Component {
    render() {
        const style = this.props.data.center ? { textAlign: 'center' } : null;

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses} style={style}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            {!this.props.mutable && (
                                <HeaderBar
                                    parent={this.props.parent}
                                    editModeOn={this.props.editModeOn}
                                    data={this.props.data}
                                    onDestroy={this.props._onDestroy}
                                    onDuplicate={this.props._onDuplicate}
                                    onEdit={this.props.onEdit}
                                    required={this.props.data.required}
                                />
                            )}
                            {this.props.data.src && (
                                <img
                                    src={this.props.data.src}
                                    width={this.props.data.width}
                                    height={this.props.data.height}
                                />
                            )}
                            {!this.props.data.src && <div className="no-image">No Image</div>}
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class Rating extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
        this.state = {
            value: this.props.defaultValue !== undefined ? parseFloat(this.props.defaultValue, 10) : 0
        };
    }

    render() {
        const props = {};
        const name = this.props.data.field_name;
        props.name = this.props.data.field_name;
        props.ratingAmount = 5;

        if (this.props.mutable) {
            props.rating = this.props.defaultValue !== undefined ? parseFloat(this.props.defaultValue, 10) : 0;
            props.editing = true;
            props.disabled = this.props.read_only;
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                <StarRating
                                    {...props}
                                    labelledby={getElementLabel(this.props.data.id)}
                                    rating={this.state.value}
                                    onRatingClick={(e, ratingCache) => {
                                        const value = ratingCache.rating;
                                        this.setState({ value: value });
                                        if (this.props.handleChange) {
                                            this.props.handleChange(e);
                                        }
                                    }}
                                />
                                <input name={name} value={this.state.value} type="hidden" />
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class HyperLink extends React.Component {
    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        return (
            <div className={baseClasses}>
                {this.props.editElement ? (
                    this.props.editElement
                ) : (
                    <div>
                        <ComponentHeader {...this.props} />
                        <div className="form-group">
                            <a target="_blank" href={this.props.data.href}>
                                {this.props.data.content}
                            </a>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

class Download extends React.Component {
    render() {
        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <a href={`${this.props.download_path}?id=${this.props.data.file_path}`}>
                                    {this.props.data.content}
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class Camera extends React.Component {
    constructor(props) {
        super(props);
        this.state = { img: null };
    }

    displayImage = e => {
        const self = this;
        const target = e.target;
        let file;
        let reader;

        if (target.files && target.files.length) {
            file = target.files[0];
            // eslint-disable-next-line no-undef
            reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onloadend = () => {
                self.setState({
                    img: reader.result
                });
            };
        }
    };

    clearImage = () => {
        this.setState({
            img: null
        });
    };

    render() {
        let baseClasses = 'SortableItem rfb-item';
        const name = this.props.data.field_name;
        const fileInputStyle = this.state.img ? { display: 'none' } : null;
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }
        let sourceDataURL;
        if (this.props.read_only === true && this.props.defaultValue && this.props.defaultValue.length > 0) {
            if (this.props.defaultValue.indexOf(name > -1)) {
                sourceDataURL = this.props.defaultValue;
            } else {
                sourceDataURL = `data:image/png;base64,${this.props.defaultValue}`;
            }
        }
        //console.log('sourceDataURL', sourceDataURL);
        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                {this.props.read_only === true &&
                                this.props.defaultValue &&
                                this.props.defaultValue.length > 0 ? (
                                    <div>
                                        <img src={sourceDataURL} />
                                    </div>
                                ) : (
                                    <div className="image-upload-container">
                                        <div style={fileInputStyle}>
                                            <input
                                                name={name}
                                                type="file"
                                                accept="image/*"
                                                capture="camera"
                                                className="image-upload"
                                                onChange={this.displayImage}
                                            />
                                            <div className="image-upload-control">
                                                <div className="btn btn-default btn-school">
                                                    <i className="fas fa-camera"></i> Upload Photo
                                                </div>
                                                <p>Select an image from your computer or device.</p>
                                            </div>
                                        </div>

                                        {this.state.img && (
                                            <div>
                                                <img
                                                    src={this.state.img}
                                                    height="100"
                                                    className="image-upload-preview"
                                                />
                                                <br />
                                                <div
                                                    className="btn btn-school btn-image-clear"
                                                    onClick={this.clearImage}
                                                >
                                                    <i className="fas fa-times"></i> Clear Photo
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class RangeElement extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
        this.state = {
            rangeAnnounced: false,
            value:
                props.defaultValue !== undefined
                    ? parseInt(props.defaultValue, 10)
                    : parseInt(props.data.default_value, 10)
        };
    }

    changeValue = e => {
        //console.log(e);
        this.setState({
            value: e.target.value,
            rangeAnnounced: true
        });

        if (this.props.handleChange) {
            this.props.handleChange(e);
        }
    };

    /**
     * The question's bounds, normalized so the slider — and the bookend-label
     * comparisons in `formatter` — always work on numbers rather than on
     * whatever the form builder happened to persist. This read-side guard is
     * what keeps questions already saved with stringified bounds working; see
     * `helpersScreener.toNumericQuestionProp`.
     *
     * @returns {{min: *, max: *, step: *}}
     */
    getBounds() {
        return {
            min: helpersScreener.toNumericQuestionProp(this.props.data.min_value),
            max: helpersScreener.toNumericQuestionProp(this.props.data.max_value),
            step: helpersScreener.toNumericQuestionProp(this.props.data.step)
        };
    }

    formatter = value => {
        const { min, max } = this.getBounds();

        if (value === min) {
            return `${value} ${this.props.data.min_label}`;
        }

        if (value === max) {
            return `${value} ${this.props.data.max_label}`;
        }

        // For first reading of the range, we need to announce the range
        // It helps screen reader users to understand the range
        if (!this.state.rangeAnnounced) {
            return `Current value is ${value}. Minimum is ${min}. Maximum is ${max}.`;
        }

        return value;
    };

    render() {
        const props = {};
        const name = this.props.data.field_name;
        const bounds = this.getBounds();

        props.type = 'range';
        props.list = `tickmarks_${name}`;
        props.min = bounds.min;
        props.max = bounds.max;
        props.step = bounds.step;

        if (this.props.read_only) {
            props.disabled = 'disabled';
        }

        let marks = {};
        let ticks = [];
        for (let i = props.min; i <= props.max; i++) {
            marks[i] = i;
            ticks.push(i);
        }
        //props.marks = marks;
        props.ticks = ticks.map(t => {
            return t;
        });
        //props.ticks = marks;

        props.value = this.state.value;
        //props.onChange = this.changeValue;
        props.change = this.changeValue;

        if (this.props.mutable) {
            props.ref = this.inputField;
        }

        const datalist = [];
        for (let i = parseInt(props.min_value, 10); i <= parseInt(props.max_value, 10); i += parseInt(props.step, 10)) {
            datalist.push(i);
        }

        //console.log('datalist', datalist)
        /*props.ticks_labels = datalist.map((item, index) => {
            return index;
        })*/

        const oneBig = 100 / (datalist.length - 1);

        const _datalist = datalist.map((d, idx) => <option key={`${props.list}_${idx}`}>{d}</option>);

        const visible_marks = datalist.map((d, idx) => {
            const option_props = {};
            let w = oneBig;
            if (idx === 0 || idx === datalist.length - 1) {
                w = oneBig / 2;
            }
            option_props.key = `${props.list}_label_${idx}`;
            option_props.style = { width: `${w}%` };
            if (idx === datalist.length - 1) {
                // The final tick label is half-width and hugs the trailing edge
                // of the track, which is the left under `dir="rtl"` — logical
                // `end` keeps it pinned to the right tick either way.
                option_props.style = { width: `${w}%`, textAlign: 'end' };
            }
            return <label {...option_props}>{d}</label>;
        });

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className="form-group">
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                            </div>

                            <div className="range">
                                {/* Flex + `space-between` already reverses under `dir="rtl"`, so the
                                    min bookend follows the slider's low end. The alignment inside
                                    each bookend must follow suit — hence logical `start`/`end`
                                    rather than the physical `text-left`/`text-right` classes. */}
                                <Flex style={{ justifyContent: 'space-between' }}>
                                    <span className="range-nav" style={{ textAlign: 'start' }}>
                                        {this.props.data.min_label}
                                    </span>
                                    <span className="range-nav" style={{ textAlign: 'end' }}>
                                        {this.props.data.max_label}
                                    </span>
                                </Flex>
                                <ReactBootstrapSlider
                                    // bootstrap-slider reads the computed direction off the
                                    // element and mirrors the track itself, putting the minimum
                                    // on the right under `dir="rtl"`. It resolves `rtl` once, in
                                    // componentDidMount, and never again — so the direction is
                                    // also the key, forcing a remount (and a re-resolve) when
                                    // the respondent switches to a language that reads the
                                    // other way. Undefined direction leaves the key stable.
                                    key={`slider_${this.props.direction || 'default'}`}
                                    formatter={value => this.formatter(value)}
                                    labelledby={getElementLabel(this.props.data.id)}
                                    rtl="auto"
                                    {...props}
                                />
                                {/*<Slider dots={true} {...props} />*/}
                            </div>
                            <div className="visible_marks">{visible_marks}</div>
                            <input name={name} value={this.state.value} type="hidden" />
                            <datalist id={props.list}>{_datalist}</datalist>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

class Captcha extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
        this.iframeRef = React.createRef();
        this.state = { value: this.props.defaultValue, expanded: false };
        this.handleMessage = this.handleMessage.bind(this);
        this.handleWindowBlur = this.handleWindowBlur.bind(this);
    }

    componentDidMount() {
        window.addEventListener('message', this.handleMessage);
        window.addEventListener('blur', this.handleWindowBlur);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
        window.removeEventListener('blur', this.handleWindowBlur);
    }

    handleWindowBlur() {
        if (document.activeElement === this.iframeRef.current) {
            this.setState({ expanded: true });
        }
    }

    handleMessage(event) {
        if (!event.data || !event.data.type) return;

        try {
            const embedOrigin = new URL(this.props.data.captcha_embed_url).origin;
            if (event.origin !== embedOrigin) return;
        } catch (e) {
            return;
        }

        switch (event.data.type) {
            case 'captcha-token':
                this.setState({ value: event.data.token, expanded: false });
                if (this.props.handleChange) {
                    this.props.handleChange(event.data.token);
                }
                break;
            case 'captcha-expired':
            case 'captcha-error':
                this.setState({ value: '', expanded: false });
                if (this.props.handleChange) {
                    this.props.handleChange('');
                }
                break;
            default:
                break;
        }
    }

    render() {
        const props = {};
        props.type = 'hidden';
        props.className = 'form-control';
        props.name = this.props.data.field_name;
        if (this.props.mutable) {
            props.ref = this.inputField;
        }

        let baseClasses = 'SortableItem rfb-item';
        if (this.props.data.pageBreakBefore) {
            baseClasses += ' alwaysbreak';
        }

        let should_show = helpersScreener.checkQuestionLogic(
            this.props.data,
            this.props.all_questions,
            this.props.page_index,
            this.props.answers_by_form_element_name,
            this.props.show_qualification
        );
        if (should_show || this.props.editElement || this.props.read_only) {
            return (
                <div className={baseClasses}>
                    {this.props.editElement ? (
                        this.props.editElement
                    ) : (
                        <div>
                            <ComponentHeader {...this.props} />
                            <div className={helpersScreener.getInputParentClassName(props.name)}>
                                <ComponentLabel
                                    {...this.props}
                                    isQuestionLogicVisible={this.props.show_qualification && this.props.isQuestionLogic}
                                />
                                {this.props.read_only === true || this.props.defaultValue !== undefined ? (
                                    <>
                                        {this.props.defaultValue
                                            ? helpersScreener.getCaptchaValueHumanReadable(this.props.defaultValue)
                                            : ''}
                                    </>
                                ) : (
                                    <div style={{ position: 'relative', height: 78, width: 304 }}>
                                        <iframe
                                            ref={this.iframeRef}
                                            src={`${this.props.data.captcha_embed_url}${
                                                (this.props.data.captcha_embed_url || '').includes('?') ? '&' : '?'
                                            }parentOrigin=${encodeURIComponent(window.location.origin)}`}
                                            width={308}
                                            height={this.state.expanded ? 500 : 78}
                                            frameBorder="0"
                                            scrolling="no"
                                            title="CAPTCHA"
                                            style={{
                                                border: 'none',
                                                position: this.state.expanded ? 'absolute' : 'static',
                                                top: 0,
                                                // Expanded overlay hugs the inline-start edge of
                                                // its relative parent, so it stays on-screen
                                                // under either direction.
                                                insetInlineStart: 0,
                                                zIndex: this.state.expanded ? 10 : 'auto'
                                            }}
                                        />
                                    </div>
                                )}
                                <input
                                    {...props}
                                    required={this.props.data.required}
                                    value={this.state.value}
                                    aria-label={getElementLabel(this.props.data.id)}
                                />
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

FormElements.Header = Header;
FormElements.Paragraph = Paragraph;
FormElements.Label = Label;
FormElements.LineBreak = LineBreak;
FormElements.TextInput = TextInput;
FormElements.NumberInput = NumberInput;
FormElements.TextArea = TextArea;
FormElements.Dropdown = Dropdown;
FormElements.Signature = Signature;
FormElements.Checkboxes = Checkboxes;
FormElements.Matrix = Matrix;
FormElements.DatePicker = DatePicker;
FormElements.RadioButtons = RadioButtons;
FormElements.Image = Image;
FormElements.Rating = Rating;
FormElements.Tags = Tags;
FormElements.HyperLink = HyperLink;
FormElements.Download = Download;
FormElements.Camera = Camera;
FormElements.RangeElement = RangeElement;
FormElements.AddPipeInput = AddPipeInput;
FormElements.FileUpload = FileUpload;
FormElements.HiddenValue = HiddenValue;
FormElements.Captcha = Captcha;

export default FormElements;
